import { HttpRequest } from "./HttpRequest";
import { delay } from "q";
import { singleRAData } from '../mock/single-ra-data.mock';
import { apiUrl } from './Defaults';
import { AuthMessages } from "../constants/messages";

export class AuthAPI {
  constructor() {
    this._url = `${apiUrl}/user`;
    this._httpRequest = new HttpRequest();
    this.login = this.login.bind(this);
  }

  async login(authData, recaptchaToken) {
    if (!authData) {
      throw new Error(AuthMessages.requiredArguments);
    }

    return await this._httpRequest.post(`${this._url}/login`, authData, { grChallangeToken: recaptchaToken });
  }

  async loginAd(accessToken, recaptchaToken) {
    if (!accessToken) {
      throw new Error(AuthMessages.requiredArguments);
    }
    const payload = { 'token': accessToken };
    return await this._httpRequest.post(`${this._url}/login-sso`, payload, { grChallangeToken: recaptchaToken });
  }
}

export default new AuthAPI();
